
export default {
    name: 'en-tete-bon-facture',
    components: {},
    props: [],
    data() {
        return {
        }
    },

    computed: {

    },

    mounted() {
        
    },

    methods: {

    }
}


